import React from 'react';
import { Button, Label, Row } from 'reactstrap';
import { StatusRightTitle } from "@/components/";
import styles from './index.module.scss';
import { Constants, Dictionary, Enums } from "@utils";
import moment from 'moment';
import { CheckBox } from 'devextreme-react';

interface ButtonProps {
    save(data: any): void;
    check(data: any, dimensionData: any, currentYear:number): void;
    toggleEditing(dimData: any, edit: boolean,typed:any): void;
    setChkEnded?(chkEnded: boolean): void;
    startTour?(): void;
    chkEnded?: boolean;
    step: number;
    dimensionData: any;
    followupLabels: Dictionary<string, string>;
    formMasters: any;
    currentYear: number ;
    currentPeriod?:any;
    getPermissions?: Function;
    currentUser: any;
    screen: string;
    initialValidate?: boolean;
    stepTour?: number;
    typed?:any;
 
}

const Buttons: React.FC<ButtonProps> = ({save, check, toggleEditing, setChkEnded, startTour, stepTour, formMasters,
        initialValidate, chkEnded, screen, getPermissions, step, dimensionData, followupLabels, currentPeriod, currentYear, currentUser,typed}: ButtonProps) => {
      
    let yearPeriod = step === 4 && currentPeriod ? moment.utc(new Date(currentPeriod.OCTAVIAFechaInicio)).tz(Constants.GeneralFormats.TIME_ZONE).format("YYYY") : null;
    let redBtnName = (step === 4) ? followupLabels.get("saveBtn") : followupLabels.get("verifyBtn")
    let greyBtnName = (step === 4) ? followupLabels.get("approveBtn") : 
    (dimensionData?.CodigoDimension == Enums.FollowupState.planning ||
        dimensionData?.CodigoDimension == Enums.FollowupState.substantialModifications 
        ? followupLabels.get("sendFollowBtn") 
        : followupLabels.get("closeFollowBtn")
        );
    let isApproved = currentPeriod?.EstadoPeriodoCod === Enums.FollowupState.approved
    let isPresented = currentPeriod?.EstadoPeriodoCod === Enums.FollowupState.presented || isApproved;

    let editingLabel = !dimensionData?.EnEdicion ? followupLabels.get("startEditing") : (currentUser.currentUser.userPrincipalName === dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "") ? followupLabels.get("endEditing") : (followupLabels.get("inEditionBy") + " " + (dimensionData?.PProaModifiedBy?.Title)))
    let disabledEditing = !dimensionData?.EnEdicion ? true : (currentUser.currentUser.userPrincipalName === dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "") ? false : true)
    let disabledBtnEdit = !dimensionData?.EnEdicion ? false : (currentUser.currentUser.userPrincipalName === dimensionData?.PProaModifiedBy?.Name?.replace("i:0#.f|membership|", "") ? false : true)
        
    let hasPermission = getPermissions?.()
    let widthRow = (step === 4) ? (isPresented && hasPermission) ? "3" : "2" : "2";
    let canEdit = (screen === Enums.FollowupState.edit)
    
    let reportId = formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.narrativeReport)?.Id
    let indicatorId = formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.indicators)?.Id
    let beneficiariesId = formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.beneficiaries)?.Id
    let financialId = formMasters.followupDimensions.find((x: any) => x.OCTAVIACodigo === Enums.FollowupDimensions.financial)?.Id

    if(stepTour > 1){
        if(dimensionData?.DimensionId === indicatorId){
            canEdit = true
            disabledEditing = true
            disabledBtnEdit = true
            if(stepTour <= 5) editingLabel = followupLabels.get("startEditing")
            if(stepTour >= 8) editingLabel = followupLabels.get("endEditing")
            if(stepTour === 6) editingLabel = followupLabels.get("inEditionBy") + "Syntax"
            if(stepTour === 7) canEdit = false
        }else if (dimensionData?.DimensionId === reportId){
            if(stepTour > 8){
                isPresented = true
                hasPermission = true
            }
            canEdit = true
            disabledEditing = true
            disabledBtnEdit = true
            editingLabel = followupLabels.get("endEditing")
        }else{
            canEdit = true
            disabledEditing = true
            disabledBtnEdit = true
            editingLabel = followupLabels.get("endEditing")
        }
    }

    let idBtn = (dimensionData?.DimensionId === indicatorId) ? "IndicatorsTourStep5" : (dimensionData?.DimensionId === beneficiariesId) ? "BeneficiariesTourStep14" : (dimensionData?.DimensionId === financialId) ? "FinancialTourStep10" : "NarrativeRepTourStep10"
    let idBtnSave = (dimensionData?.DimensionId === indicatorId) ? "IndicatorsTourStep13" : (dimensionData?.DimensionId === reportId) ? "NarrativeRepTourStep7" : ''
    let idBtnCheck = (dimensionData?.DimensionId === indicatorId) ? "IndicatorsTourStep15" : (dimensionData?.DimensionId === reportId) ? "NarrativeRepTourStep9" : ''

    return (
        <div className={styles.stickyTitle}>
            <div className={styles.mainButtons}> 
                <Row xs={widthRow} sm={widthRow} md={widthRow} lg={widthRow} xl={widthRow}>   
                    <Button onClick={() => save(step)} disabled={!dimensionData || disabledEditing || !canEdit} id={idBtnSave}>
                        { redBtnName }
                    </Button>
                    {(((isPresented && hasPermission) || step !== 4 ) ) && 
                        <Button className={styles.disabled} onClick={() => check(step, dimensionData, currentYear)} disabled={!dimensionData || disabledEditing || !canEdit} id={idBtnCheck}>
                            { greyBtnName }
                        </Button>
                    }
                    {(step === 4) &&
                        <div className={styles.divCheck}>
                            <Label>
                                <CheckBox id={"NarrativeRepTourStep6"} value={chkEnded} disabled={!dimensionData || disabledEditing || !canEdit} onValueChanged={(e) => setChkEnded(e.value)} text={followupLabels.get("checkFinalized")} />
                            </Label>
                        </div>
                    }   
                </Row>
                <div className={styles.otherBtns}>
                    {(!!startTour) &&
                        <Button className={styles.btnAppTour}  onClick={() => startTour()} id="IndicatorsTourStep7">
                            {followupLabels.get("seeTutorial")}
                        </Button>
                    }
                    {(canEdit && !initialValidate) &&
                        <Button id={idBtn} className={styles.btnEdit} disabled={!dimensionData || disabledBtnEdit} onClick={() => toggleEditing(dimensionData, !(dimensionData?.EnEdicion),typed)}>
                            <h6  style={{margin:0}}>{ editingLabel }</h6>
                        </Button>
                    }
                </div>
            </div>
            {(step !== 4) ?
                <StatusRightTitle 
                    id="IndicatorsTourStep4"
                    title={dimensionData?.EstadoDimension || ''} 
                    subtitle={dimensionData?.ProximoCierre ? `${followupLabels.get("nextClosure")} ${dimensionData?.ProximoCierre}` : ''}
                    info={dimensionData?.UltimoCierre ? `${followupLabels.get("lastClosure")} ${dimensionData?.UltimoCierre}` : ''}
                />
            :
                <StatusRightTitle 
                    id="NarrativeRepTourStep2"
                    title={(currentPeriod?.UltimoCierre || '') + " - " + (currentPeriod?.ProximoCierre || '') + " " + yearPeriod}
                    subtitle={`${followupLabels.get("stateNarrativeLabel")}: ${currentPeriod?.EstadoPeriodo || ''}`}    
                /> 
            }
        </div>                 
    );
}

export default Buttons;